import { Box, Heading, Text } from '@chakra-ui/react'

export function BoDashboard() {
  return (
    <Box p={8}>
      <Heading size="lg" mb={4}>
        Backoffice Dashboard
      </Heading>

      <Text fontSize="md" color="gray.600">
        Dies ist eine Platzhalterseite für das Backoffice Dashboard.
      </Text>
    </Box>
  )
}

export default BoDashboard
